import london_nickel_blank from "./london_nickel_blank.png"
import london_brass_blank from "./london_brass_blank.png"
import london_nickel from "./london_nickel.png"
import oslo from "./oslo.png"
import paris_brass from "./paris_brass.png"
import paris_brass_blank from "./paris_brass_blank.png"
import paris_nickel_oxide from "./paris_nickel_oxide.png"
import stockholm_brass_blank from "./stockholm_brass_blank.png"
import stockholm_nickel from "./stockholm_nickel.png"
import berlin_brass_blank from "./berlin_brass_blank.png"
import berlin_nickel from "./berlin_nickel.png"
import copenhagen from "./copenhagen.png"
import athens from "./athens.png"
import amsterdam from "./amsterdam.png"
import tallinn from "./tallinn.png"
import rome_brass_blank from "./rome_brass_blank.png"
import rome_nickel from "./rome_nickel.png"
import rome_brass from "./rome_brass.png"
import sydney from "./sydney.png"
import madrid_brass from "./madrid_brass.png"
import madrid_nickel from "./madrid_nickel.png"
import badge_brass_round from "./badge_brass_round.png"
import badge_brass_bulge from "./badge_brass_bulge.png"
import badge_brass_ellipse from "./badge_brass_ellipse.png"
import badge_brass_ellipse_oval from "./badge_brass_ellipse_oval.png"
import badge_brass_round_military from "./badge_brass_military.png"
import badge_nickel_round from "./badge_nickel_round.png"
import badge_nickel_bulge from "./badge_nickel_bulge.png"
import badge_nickel_ellipse from "./badge_nickel_ellipse.png"
import badge_nickel_ellipse_oval from "./badge_nickel_ellipse_oval.png"
import badge_nickel_round_military from "./badge_nickel_military.png"
import badge_aluminium_round from "./badge_aluminium_round.png"
import badge_aluminium_bulge from "./badge_aluminium_bulge.png"
import badge_aluminium_ellipse from "./badge_aluminium_ellipse.png"
import badge_aluminium_ellipse_oval from "./badge_aluminium_ellipse_oval.png"
import badge_aluminium_round_military from "./badge_aluminium_military.png"
import badge_plastic_round from "./badge_plastic_round.png"
import badge_plastic_round_2 from "./badge_plastic_round_2.png"
import badge_plastic_bulge from "./badge_plastic_bulge.png"
import badge_plastic_ellipse from "./badge_plastic_ellipse.png"
import badge_plastic_ellipse_oval from "./badge_plastic_ellipse_oval.png"
import badge_plastic_rounded_sides from "./badge_plastic_rounded_sides.png"
import badge_ecoboard_round from "./badge_ecoboard_round.png"
import badge_ecoboard_bulge from "./badge_ecoboard_bulge.png"
import badge_ecoboard_ellipse from "./badge_ecoboard_ellipse.png"
import badge_ecoboard_ellipse_oval from "./badge_ecoboard_ellipse_oval.png"
import label_plastic from "./label_plastic.png"
import label_print from "./label_print.png"
import aluminium_sign from "./aluminium_sign.png"
import double_sided_forex from "./double_sided.png"
import wood from "./wood.png"
import badge_oak_round from "./badge_oak_round.png"
import badge_oak_bulge from "./badge_oak_bulge.png"
import badge_oak_ellipse from "./badge_oak_ellipse.png"
import badge_oak_ellipse_oval from "./badge_oak_ellipse_oval.png"
import badge_oak_round_military from "./badge_oak_round_military.png"
import badge_cherry_round from "./badge_cherry_round.png"
import badge_cherry_bulge from "./badge_cherry_bulge.png"
import badge_cherry_ellipse from "./badge_cherry_ellipse.png"
import badge_cherry_ellipse_oval from "./badge_cherry_ellipse_oval.png"
import badge_cherry_round_military from "./badge_cherry_round_military.png"
import badge_birch_round from "./badge_birch_round.png"
import badge_birch_bulge from "./badge_birch_bulge.png"
import badge_birch_ellipse from "./badge_birch_ellipse.png"
import badge_birch_ellipse_oval from "./badge_birch_ellipse_oval.png"
import badge_birch_round_military from "./badge_birch_round_military.png"
import prague_brass_blank from "./prague_brass_blank.png"
import lisbon_brass_blank from "./lisbon_brass_blank.png"
import lisbon_nickel from "./lisbon_nickel.png"
import dublin_brass_blank from "./dublin_brass_blank.png"
import stainless_28x49 from "./stainless_28x49.png"
import stainless_30x30 from "./stainless_30x30.png"
import stainless_60x18 from "./stainless_60x18.png"
import stainless_60x30 from "./stainless_60x30.png"
import stainless_50x50 from "./stainless_50x50.png"
import stainless_80x25 from "./stainless_80x25.png"
import stainless_100x40 from "./stainless_100x40.png"
import stainless_150x50 from "./stainless_150x50.png"
import stainless_170x70 from "./stainless_170x70.png"
import kiev_brass from "./kiev_brass.png"
import kiev_nickel from "./kiev_nickel.png"
import budapest_brass from "./budapest_brass.png"
import budapest_nickel from "./budapest_nickel.png"

const icons: IconMap = {
  london_nickel_blank,
  london_brass_blank,
  london_nickel,
  oslo,
  paris_brass,
  paris_brass_blank,
  paris_nickel_oxide,
  stockholm_brass_blank,
  stockholm_nickel,
  berlin_brass_blank,
  berlin_nickel,
  copenhagen,
  athens,
  amsterdam,
  tallinn,
  rome_brass_blank,
  rome_nickel,
  rome_brass,
  sydney,
  madrid_brass,
  madrid_nickel,
  badge_brass_round,
  badge_brass_bulge,
  badge_brass_ellipse,
  badge_brass_ellipse_oval,
  badge_brass_round_military,
  badge_nickel_round,
  badge_nickel_bulge,
  badge_nickel_ellipse,
  badge_nickel_ellipse_oval,
  badge_nickel_round_military,
  badge_aluminium_round,
  badge_aluminium_bulge,
  badge_aluminium_ellipse,
  badge_aluminium_ellipse_oval,
  badge_aluminium_round_military,
  badge_plastic_round,
  badge_plastic_round_2,
  badge_plastic_bulge,
  badge_plastic_ellipse,
  badge_plastic_ellipse_oval,
  badge_plastic_rounded_sides,
  badge_ecoboard_round,
  badge_ecoboard_bulge,
  badge_ecoboard_ellipse,
  badge_ecoboard_ellipse_oval,
  label_anodised_aluminium: aluminium_sign,
  label_lacquered_aluminium: aluminium_sign,
  label_plastic,
  label_print,
  label_laser: label_print,
  double_sided_forex,
  double_sided_alu: double_sided_forex,
  double_sided_ecoboard: double_sided_forex,
  wood_maple: wood,
  wood_oak: wood,
  wood_cherry: wood,
  wood_birch: wood,
  badge_oak_round,
  badge_oak_bulge,
  badge_oak_ellipse,
  badge_oak_ellipse_oval,
  badge_oak_round_military,
  badge_cherry_round,
  badge_cherry_bulge,
  badge_cherry_ellipse,
  badge_cherry_ellipse_oval,
  badge_cherry_round_military,
  badge_birch_round,
  badge_birch_bulge,
  badge_birch_ellipse,
  badge_birch_ellipse_oval,
  badge_birch_round_military,
  prague_brass_blank,
  lisbon_brass_blank,
  lisbon_nickel,
  dublin_brass_blank,
  stainless_28x49,
  stainless_30x30,
  stainless_60x18,
  stainless_60x30,
  stainless_50x50,
  stainless_80x25,
  stainless_100x40,
  stainless_150x50,
  stainless_170x70,
  kiev_brass,
  kiev_nickel,
  budapest_brass,
  budapest_nickel,
}

export default icons
